import { render, staticRenderFns } from "./ReportsSalesSectionView.vue?vue&type=template&id=1f28229d&scoped=true"
import script from "./ReportsSalesSectionView.vue?vue&type=script&lang=js"
export * from "./ReportsSalesSectionView.vue?vue&type=script&lang=js"
import style0 from "./ReportsSalesSectionView.vue?vue&type=style&index=0&id=1f28229d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f28229d",
  null
  
)

export default component.exports